import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/course/video"

const courseVideo = {
  courseVideoListPage(pageSize, limit, courseId) {
    return axios.get(pre + `/courseVideoListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          courseId: courseId
        }
    });
  },
  courseVideoInfo(id) {
    return axios.get(pre + `/courseVideoInfo`, {params: {id: id}});
  },

  getVideosPlayUrl(videoId) {
    return axios.get(pre + `/getVideosPlayUrl`, {params: {videoId: videoId}});
  },
  courseVideoSave(params) {
    return axios.post(pre + `/courseVideoSave`, qs.stringify(params));
  },
  courseVideoDelete(id) {
    return axios.delete(pre + `/courseVideoDelete`, {params: {id: id}});
  },
}
export default courseVideo;



// WEBPACK FOOTER //
// ./src/api/course/courseVideo.js